import * as types from 'modules/campaigns/actionTypes';
import { MULTIPLE_FETCH_FAILURE, MULTIPLE_FETCH_SUCCESS } from 'modules/checklists/actionTypes';
import * as actionTypes from 'modules/interventions/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} IsOpenState */

/** @type {IsOpenState} */
const initialState = false;

const open = () => true;
const close = () => false;

export default createReducer(initialState, {
  [LOCATION_CHANGE]: close,
  [actionTypes.OPEN_CHECKLISTS_IMPORT_MODAL]: open,
  [actionTypes.CLOSE_CHECKLISTS_IMPORT_MODAL]: close,
  [actionTypes.IMPORT_CHECKLISTS_SUCCESS]: close,
  [actionTypes.IMPORT_CHECKLISTS_FAILURE]: close,
  [types.IMPORT_CHECKLISTS_SUCCESS]: close,
  [types.IMPORT_CHECKLISTS_FAILURE]: close,
  [MULTIPLE_FETCH_SUCCESS]: close,
  [MULTIPLE_FETCH_FAILURE]: close,
});
